<template>
  <div>
      <div class="tui-popup-box">

        <div class="tui-product-box">
          <img :src="banner.pictureUrl" class="tui-popup-img"/>
          <div class="tui-popup-price">
            <div class="tui-name">{{productInfo.name}}</div>
            <div class="tui-amount tui-bold">{{productInfo.marketPrice}}</div>
          </div>
        </div>

        <div class="tui-popup-scroll">
          <div class="tui-scrollview-box">

<!--            <div class="tui-bold tui-attr-title">颜色</div>-->
<!--            <div class="tui-attr-box">-->
<!--              <div class="tui-attr-item" :class="index1==index?'tui-attr-active':''" v-for="(item, index) in colorList" :key="index" @click="index1=index">{{item}}</div>-->
<!--            </div>-->

<!--            <div class="tui-bold tui-attr-title">尺寸</div>-->
<!--            <div class="tui-attr-box">-->
<!--              <div class="tui-attr-item radius-8" v-for="(item, index) in typeList" :key="index">{{item}}</div>-->
<!--            </div>-->

            <div class="tui-bold tui-attr-title">数量</div>
            <div class="tui-attr-box">
              <van-stepper v-model="value" />
            </div>

<!--            <div class="tui-bold tui-attr-title">分期</div>-->
<!--            <div class="tui-attr-box">-->
<!--              <div class="tui-attr-item radius-8">¥220.50 × 36期</div>-->
<!--              <div class="tui-attr-item radius-8">¥220.50 × 36期</div>-->
<!--            </div>-->

            <!--二维数组遍历-->
            <div  v-for="(item, index) in lists" :key="index">
              <div class="tui-bold tui-attr-title">{{item.title}}</div>
              <div class="tui-attr-box">
                <div class="tui-attr-item radius-8" v-for="(item, index) in item.list" :key="index" :class="index1==index?'tui-attr-active':''">{{item}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="tui-popup-btn">
          <div class="flex margin-lr-sm">
            <div class="tui-flex-1">
              <van-button plain round block color="#979797" type="primary" @click="shop">加入购物车</van-button>
            </div>
            <div class="tui-flex-1">
              <van-button round block color="var(--theme-color-main)" type="primary" @click="submit">立即购买</van-button>
            </div>
          </div>
        </div>
<!--        <div class="tui-right">-->
<!--          <van-icon name="close" @click="popupShow=false" size="22px" color="#848897"/>-->
<!--        </div>-->
      </div>
    <!--底部选择层-->
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  props: {
      productInfo: {
          type: Object,
          default: null
      },
      banner: {
          type: Object,
          default: null
      },
  },
  data() {
    return {
      index1:0,
      colorList:['黑色','白色','灰色','蓝色','绿色'],
      typeList:['20001+1000','20008+250','20008+365','20008','20008'],
      // lists:[
      //   {
      //     title:'颜色',
      //     list:[{
      //       name:'黑色'
      //     }]
      //   },
      //   {
      //     title:'规格',
      //     list:['20001+1000','20008+250','20008+365','20008','20008']
      //   }
      // ]
    };
  },
  methods: {
    shop(e) {
      // this.$emit("shopClick");
        this.$toast('添加成功！');
    },
    submit(e){
      // this.$emit("submitClick");
      wx.miniProgram.navigateTo({
        url: '/pages/submitOrder/submitOrder'
      })
    },
  }
};
</script>

<style lang="scss" scoped>
  /*底部选择弹层*/
  .tui-flex-1{
    flex: 1;
    margin: 0 10px;
  }
  .tui-popup-box {
    position: relative;
    padding: 30px 0 100px 0;
  }

  .tui-popup-btn {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    padding-bottom: 30px;
  }

  .tui-product-box {
    display: flex;
    font-size: 24px;
    padding-bottom: 30px;
    border-bottom: 1px solid #DEDEDE;
    margin: 0 30px;
  }

  .tui-popup-img {
    height: 200px;
    width: 200px;
    border-radius: 24px;
    display: block;
  }

  .tui-popup-price {
    padding-left: 20px;
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .tui-name{
      height: 80px;
      font-size: 28px;
      color: #333333;
      width: 420px;
    }
    .tui-amount {
      color: #ff201f;
      font-size: 58px;
    }
    .tui-amount:before{
      content : "¥";
      font-size: 28px;
      margin-right: 10px;
    }
  }
  .tui-popup-scroll {
    height: 600px;
    font-size: 26px;
    overflow: scroll;
  }

  .tui-scrollview-box {
    padding: 30px 30px 60px 30px;
    box-sizing: border-box;
  }

  .tui-attr-title {
    padding: 10px 0;
    color: #333;
    font-size: 28px;
  }

  .tui-attr-box {
    font-size: 0;
    padding: 20px 0;
  }

  .tui-attr-item {
    max-width: 100%;
    min-width: 120px;
    height: 60px;
    display: -webkit-inline-flex;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #F1F1F1;
    padding: 0 20px;
    box-sizing: border-box;
    margin-right: 30px;
    margin-bottom: 20px;
    font-size: 26px;
    border-radius: 30px;
  }

  .tui-attr-active {
    background: $theme-color-main !important;
    color: #fff;
    font-weight: bold;
    position: relative;
  }
  .radius-8{
    border-radius: 8px;
  }
  .tui-right {
    position: absolute;
    right: 30px;
    top: 30px;
  }
  /*底部选择弹层*/
</style>

